import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aeafff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drop-down__menu-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "drop-down__menu-header-information" }
const _hoisted_4 = { class: "drop-down__user-name" }
const _hoisted_5 = { class: "drop-down__user-email" }
const _hoisted_6 = { class: "drop-down__user-extra" }
const _hoisted_7 = { class: "profile_button-section" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Acessar perfil ")
const _hoisted_9 = {
  class: "profile-button__icon",
  "aria-hidden": "true"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "menu-section first"
}
const _hoisted_12 = { class: "section-list line" }
const _hoisted_13 = { class: "menu_body" }
const _hoisted_14 = {
  key: 0,
  class: "menu-section"
}
const _hoisted_15 = { class: "section-title" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Administração", -1))
const _hoisted_18 = { class: "section-list" }
const _hoisted_19 = { class: "menu-section" }
const _hoisted_20 = { class: "section-title" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Treinamentos", -1))
const _hoisted_23 = { class: "section-list" }
const _hoisted_24 = {
  key: 1,
  class: "menu-section"
}
const _hoisted_25 = { class: "section-title" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loja Decola", -1))
const _hoisted_28 = { class: "section-list" }
const _hoisted_29 = {
  key: 2,
  class: "menu-section"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-plus" }, "+"),
  /*#__PURE__*/_createElementVNode("span", null, "Mais")
], -1))
const _hoisted_31 = { class: "section-list" }
const _hoisted_32 = { class: "menu_footer" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Sair ")
const _hoisted_34 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item = _resolveComponent("item")!
  const _component_Suggestion = _resolveComponent("Suggestion")!
  const _component_LogoutConfirm = _resolveComponent("LogoutConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: _normalizeClass(['drop-down__menu-box', { open: _ctx.isOpened }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "header__dropdown-image",
          src: _ctx.userPhoto || '',
          alt: "Sua foto de perfil.",
          onError: _cache[0] || (_cache[0] = 
          event =>
            (event.target.src = require('../../../../assets/static/icons/onerror-user.png'))
        )
        }, null, 40, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.user.socialName || _ctx.user.name), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.email), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.user.companies?.map(c => c.name).join(", ")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "profile-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openItem(_ctx.student)))
        }, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("img", {
              src: 
              require(`../../../../assets/static/main-menu/arrow-right.svg`)
            ,
              alt: ""
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      (_ctx.initialSection.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initialSection, (item) => {
                return (_openBlock(), _createBlock(_component_item, {
                  key: item.title,
                  item: item,
                  class: _normalizeClass(_ctx.disabledClass(item))
                }, null, 8, ["item", "class"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.adminSection.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: require(`../../../../assets/static/main-menu/admin-icon.svg`),
                  alt: ""
                }, null, 8, _hoisted_16),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminSection, (item) => {
                  return (_openBlock(), _createBlock(_component_item, {
                    key: item.title,
                    item: item,
                    class: _normalizeClass(_ctx.disabledClass(item))
                  }, null, 8, ["item", "class"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              src: require(`../../../../assets/static/main-menu/events.svg`),
              alt: ""
            }, null, 8, _hoisted_21),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainings, (item) => {
              return (_openBlock(), _createBlock(_component_item, {
                key: item.title,
                item: item,
                class: _normalizeClass(_ctx.disabledClass(item))
              }, null, 8, ["item", "class"]))
            }), 128))
          ])
        ]),
        (_ctx.storeSection.length && !_ctx.isCirculoTemplate())
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("img", {
                  src: require(`../../../../assets/static/main-menu/shop.svg`),
                  alt: ""
                }, null, 8, _hoisted_26),
                _hoisted_27
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeSection, (item) => {
                  return (_openBlock(), _createBlock(_component_item, {
                    key: item.title,
                    item: item,
                    class: _normalizeClass(_ctx.disabledClass(item))
                  }, null, 8, ["item", "class"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.moreSection.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreSection, (item) => {
                  return (_openBlock(), _createBlock(_component_item, {
                    key: item.title,
                    item: item,
                    class: _normalizeClass(_ctx.disabledClass(item))
                  }, null, 8, ["item", "class"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", {
          class: "drop-down__logout",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openLogoutModal && _ctx.openLogoutModal(...args)))
        }, [
          _hoisted_33,
          _createElementVNode("img", {
            width: "20",
            height: "20",
            src: require(`../../../../assets/static/main-menu/logout.svg`),
            alt: "Ícone de logout"
          }, null, 8, _hoisted_34)
        ])
      ])
    ], 2),
    _createVNode(_component_Suggestion, {
      isOpen: _ctx.showConfirmation,
      onToggle: _ctx.closeSuggestionModal
    }, null, 8, ["isOpen", "onToggle"]),
    _createVNode(_component_LogoutConfirm, {
      isOpen: _ctx.isLogoutOpen,
      onClose: _ctx.closeLogoutModal,
      onConfirm: _ctx.logout
    }, null, 8, ["isOpen", "onClose", "onConfirm"])
  ], 64))
}